import React from 'react';
import './Footer.scss';

function Footer() {
  return (
    <div className='footer'>
      Scandiweb Test assignment
    </div>
  )
}

export default Footer